import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "page-layout" }
const _hoisted_2 = { class: "page-layout__header" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "page-layout__header-actions" }
const _hoisted_6 = { class: "page-layout__intro" }
const _hoisted_7 = { class: "page-layout__content" }
const _hoisted_8 = {
  key: 2,
  class: "page-layout__footer"
}
const _hoisted_9 = { class: "copy" }
const _hoisted_10 = {
  key: 0,
  class: "social-list"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_media_view = _resolveComponent("media-view")!
  const _component_page_layout_intro_text = _resolveComponent("page-layout-intro-text")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_auth_modal = _resolveComponent("auth-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_layout, {
            "align-center": "",
            wrap: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: _ctx.getHomeUrl()
              }, [
                _createElementVNode("img", {
                  class: "page-layout__header-logo",
                  src: require('@/assets/svg/logo.svg'),
                  alt: ""
                }, null, 8, _hoisted_4)
              ], 8, _hoisted_3),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "header-actions"),
                (!_ctx.checkUserRole('student'))
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "outlined",
                      color: "light",
                      class: "ml-2",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAuthModal('login')))
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" Sign In ")
                      ])),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_v_btn, {
                        variant: "outlined",
                        color: "light",
                        class: "ml-2",
                        onClick: _ctx.openProfile
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode(" My Profile ")
                        ])),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        variant: "outlined",
                        color: "light",
                        class: "ml-2",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode(" Log Out ")
                        ])),
                        _: 1
                      })
                    ], 64))
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("section", _hoisted_6, [
            (!_ctx.showGallery)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_media_view, {
                    media: _ctx.media[0],
                    active: ""
                  }, null, 8, ["media"]),
                  _createVNode(_component_page_layout_intro_text, {
                    title: _ctx.title,
                    text: _ctx.text,
                    "button-text": _ctx.buttonText,
                    "place-text-bottom": _ctx.placeTextBottom,
                    onAction: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('action')))
                  }, null, 8, ["title", "text", "button-text", "place-text-bottom"])
                ], 64))
              : (_openBlock(), _createBlock(_component_swiper, {
                  key: 1,
                  ref: "mySwiper",
                  options: _ctx.swiperOptions,
                  class: "intro-carousel",
                  autoplay: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.media, (mediaItem, idx) => {
                      return (_openBlock(), _createBlock(_component_swiper_slide, { key: idx }, {
                        default: _withCtx(() => [
                          _createVNode(_component_media_view, {
                            media: mediaItem,
                            active: _ctx.currentSlide === idx + 1
                          }, null, 8, ["media", "active"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1)),
                    _createElementVNode("div", {
                      class: "swiper-button-prev",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.mySwiper.$el.swiper.slidePrev()))
                    }),
                    _createElementVNode("div", {
                      class: "swiper-button-next",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$refs.mySwiper.$el.swiper.slideNext()))
                    }),
                    _createVNode(_component_page_layout_intro_text, {
                      title: _ctx.title,
                      text: _ctx.text,
                      "button-text": _ctx.buttonText,
                      "place-text-bottom": _ctx.placeTextBottom,
                      onAction: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('action')))
                    }, null, 8, ["title", "text", "button-text", "place-text-bottom"])
                  ]),
                  _: 1
                }, 8, ["options"]))
          ]),
          _createElementVNode("section", _hoisted_7, [
            _createVNode(_component_v_container, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            })
          ])
        ], 64))
      : (_openBlock(), _createBlock(_component_v_layout, {
          key: 1,
          "align-center": "",
          "justify-center": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary"
            })
          ]),
          _: 1
        })),
    (_ctx.organization)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_8, [
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_layout, {
                "align-center": "",
                wrap: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[10] || (_cache[10] = _createTextVNode(" Powered by ")),
                    _cache[11] || (_cache[11] = _createElementVNode("a", {
                      href: "https://www.studenthousingsoftware.com/",
                      target: "_blank"
                    }, "roomchoice.com", -1)),
                    _createTextVNode(" © 2014-" + _toDisplayString((new Date()).getFullYear()) + " Room Choice. All Rights Reserved ", 1)
                  ]),
                  _createVNode(_component_v_spacer),
                  (_ctx.socialsFilled.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialsFilled, (social, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: "social-list__item"
                          }, [
                            _createElementVNode("a", {
                              href: social.link,
                              target: "_blank"
                            }, [
                              _createElementVNode("img", {
                                src: require(`@/assets/svg/${social.icon}.svg`),
                                alt: ""
                              }, null, 8, _hoisted_12)
                            ], 8, _hoisted_11)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_auth_modal)
  ]))
}